import { render } from "./CreditStatementCard.vue?vue&type=template&id=6569f66c&scoped=true"
import script from "./CreditStatementCard.vue?vue&type=script&lang=js"
export * from "./CreditStatementCard.vue?vue&type=script&lang=js"

import "./CreditStatementCard.vue?vue&type=style&index=0&id=6569f66c&scoped=true&lang=css"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6569f66c"]])

export default __exports__